module.exports = __webpack_public_path__ + "img/40_69_007_350.91bc8798.jpg";